import { render } from "./LoginPassword.vue?vue&type=template&id=fa516636&scoped=true"
import script from "./LoginPassword.vue?vue&type=script&lang=js"
export * from "./LoginPassword.vue?vue&type=script&lang=js"

import "./LoginPassword.vue?vue&type=style&index=0&id=fa516636&lang=scss&scoped=true"
import "./LoginPassword.vue?vue&type=style&index=1&id=fa516636&lang=scss"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa516636"]])

export default __exports__